import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import User from '../../../models/user';
import { addAllowedUser, addBlockedUser } from '../../moderation-v2/users/state/actions/add-user';
import {
  removeAllowedUser,
  removeBlockedUser
} from '../../moderation-v2/users/state/actions/remove-user';
import { UserAvatar } from '../../moderation-v2/comments-and-posts/dashboard/components';
import { assignRole } from '../../settings/state/actions/roles';
import { addUserSuccess } from '../../moderation-v2/users/state/actions';
import { TModerationUser } from '../../moderation-v2/users/state/types';
import UserListController from './user-list-controller';
import Teammates from './teammates';

const mapDispatchToProps = dispatch => ({
  addAllowedUser: props => {
    dispatch(addAllowedUser(props));
  },
  removeAllowedUser: props => {
    dispatch(removeAllowedUser(props));
  },
  addBlockedUser: props => {
    dispatch(addBlockedUser(props));
  },
  removeBlockedUser: props => {
    dispatch(removeBlockedUser(props));
  },
  assignRole: (props = {}) => {
    dispatch(addUserSuccess({ type: TModerationUser.TeamMembers, ...props }));
    dispatch(assignRole(props));
  }
});

class UsersAutocomplete extends Component {
  static propTypes = {
    users: PropTypes.array.isRequired,
    className: PropTypes.string,
    spotId: PropTypes.string,
    type: PropTypes.string,
    onItemSelected: PropTypes.func,
    onUserClick: PropTypes.func,
    eventId: PropTypes.string,
    resetSearch: PropTypes.func,
    addAllowedUser: PropTypes.func,
    addBlockedUser: PropTypes.func,
    removeAllowedUser: PropTypes.func,
    removeBlockedUser: PropTypes.func,
    assignRole: PropTypes.func,
    isViewOnlyMode: PropTypes.bool,
    userControls: PropTypes.object
  };

  static defaultProps = {
    users: [],
    onUserClick: () => {}
  };

  static displayName = 'UsersAutocomplete';

  @autobind
  onUserClick(userId, username) {
    let { onUserClick } = this.props;
    onUserClick(userId, username);
  }

  renderControlsComponent(user) {
    let {
      type,
      onItemSelected,
      spotId,
      eventId,
      resetSearch,
      teammates,
      addAllowedUser,
      addBlockedUser,
      removeAllowedUser,
      removeBlockedUser,
      isViewOnlyMode,
      assignRole,
      userControls,
      users
    } = this.props;
    let userId = user.id || user.userId;
    const usersOnList = teammates;
    let userType = '';
    let isUserOnList = false;
    if (usersOnList) {
      const searchedUsers = usersOnList.filter(el => el.id === userId);
      isUserOnList = searchedUsers.length > 0;
      userType = isUserOnList ? searchedUsers[0].type : undefined;
    }

    if (!isUserOnList) {
      isUserOnList = inUsers(
        users,
        userId,
        type === 'whitelist' ? 'isWhitelisted' : 'isBlacklisted'
      );
    }

    if (isViewOnlyMode) {
      return null;
    }

    if (userControls) {
      const UserControls = userControls;
      return <UserControls user={user} onItemSelected={onItemSelected} />;
    }

    switch (type) {
      case 'teammates':
        return (
          <Teammates
            user={user}
            onItemSelected={onItemSelected}
            userId={userId}
            spotId={spotId}
            type={userType}
            addUser={assignRole}
          />
        );
      case 'blacklist':
        return (
          <UserListController
            user={user}
            userId={userId}
            spotId={spotId}
            resetSearch={resetSearch}
            isUserOnList={isUserOnList}
            addUser={addBlockedUser}
            removeUser={removeBlockedUser}
            type={'blacklist'}
          />
        );
      case 'whitelist':
        return (
          <UserListController
            user={user}
            userId={userId}
            spotId={spotId}
            resetSearch={resetSearch}
            isUserOnList={isUserOnList}
            addUser={addAllowedUser}
            removeUser={removeAllowedUser}
            type={'whitelist'}
          />
        );
    }
    return null;
  }

  render() {
    let { users } = this.props;
    let className = 'users-autocomplete';
    if (this.props.className) {
      className += ` ${this.props.className}`;
    }

    return (
      <div className={className}>
        {users.map(user => {
          let userId = user.userId || user.id;
          user = new User().parse(user);
          let { username, displayName, email } = user;

          return (
            <div
              key={userId}
              className="autocomplete-item"
              onClick={this.onUserClick.bind(this, userId, username)}
            >
              <div className="user-image-wrapper">
                <UserAvatar user={user} avatarSize={'small'} />
              </div>
              <div className="user-deatils">
                {displayName && <div className="display-name">{displayName}</div>}
                {username && <div className="username">{`@${username}`}</div>}
                {email && <div className="username">{email}</div>}
              </div>
              {this.renderControlsComponent(user)}
            </div>
          );
        })}
      </div>
    );
  }
}

export default connect(null, mapDispatchToProps)(UsersAutocomplete);

function inUsers(users, userId, field) {
  const user = users.find(user => user.id === userId);

  return user && user[field];
}
